import {
  GMAF_CONTENT_SUBTYPES,
  GMAF_TA_OPTIONS,
} from "../components/ContentShortCutGenAI/GMAFTAFilter";

export const expandGMAFFilters = (compactFilters = "") =>
  compactFilters
    .split(";")
    .map((filterPath) => {
      const [taKey, subtypeKey, assetTypeKey] = filterPath
        .split("/")
        .filter(Boolean);
      const ta = GMAF_TA_OPTIONS.find((option) => option.key === taKey);
      const subtype = GMAF_CONTENT_SUBTYPES.find(
        (option) => option.key === subtypeKey
      );
      const assetType = subtype?.assetTypes.find(
        (option) => option.key === assetTypeKey
      );

      return [
        "Document Type/Global Medical Affairs Resources",
        ta?.label || taKey,
        subtype?.label || subtypeKey,
        assetType?.label || assetTypeKey,
      ]
        .filter(Boolean)
        .join("/");
    })
    .filter(Boolean)
    .join(";");

export const getResolvedGMAFFilters = (queryParams) => {
  const compactFilters = queryParams.get("GMAFfilters");

  return compactFilters
    ? expandGMAFFilters(compactFilters)
    : queryParams.get("filters");
};